<template>
  <div class="home">
    <div class="flex-sb">
      <Banner />
      <EmployeeService />
    </div>

    <CommonlySystem />

    <div class="flex-sb">
      <SpruceNews />
      <SpruceSystem />
    </div>
  </div>
</template>

<script>
import CommonlySystem from "./components/commonly-system";
import EmployeeService from "./components/employee-service";
import WorkWorld from "./components/work-world";
import SpruceNews from "./components/spruce-news";
import SpruceSystem from "./components/spruce-system";
import pathConfig from "@/config/requirePath";
import Banner from "./components/banner.vue";

export default {
  name: "app",
  components: {
    CommonlySystem,
    EmployeeService,
    WorkWorld,
    SpruceNews,
    SpruceSystem,
    Banner
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.home {
  width: 1200px;
  margin: 20px auto;
  /deep/ h2 {
    line-height: 16px;
    color: rgba(48, 49, 51, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
  }
  .flex-sb {
    display: flex;
    justify-content: space-between;
  }
  .more-tag {
    color: rgba(249, 106, 14, 1);
  }
  .horn-icon {
    width: 17px;
    height: 16px;
    margin: 0 10px;
  }
}
</style>
